import React from 'react';
import styles from './styles.module.css';

interface SkeletonProps {
  variant?: 'text' | 'banner' | 'card' | 'sm-text';
  height?: string;
  width?: string;
}

const Skeleton: React.FC<SkeletonProps> = ({ variant = 'text', height, width }) => {
  return (
    <div
      className={`${styles.skeleton} ${styles[`skeleton-${variant}`]}`}
      style={{ height, width }}
    />
  );
};

export default Skeleton;
